import { FC, useEffect } from "react";
import {
  ReferenceInput,
  required,
  SelectInput,
  useDataProvider,
} from "react-admin";
import { useField } from "react-final-form";
import { SchoolIdSelected } from "utils/tools";

interface WaveInputProps {
  isDisable?: boolean;
  isEdit?: boolean;
}

const WaveInput: FC<WaveInputProps> = ({ isDisable, isEdit }) => {
  const routeInput = useField("routeId");
  const busSchedulePlanInput = useField("busSchedulePlanId");
  const waveInput = useField("busScheduleId");

  const provider = useDataProvider();

  const schoolId = Number(SchoolIdSelected());

  useEffect(() => {
    if (schoolId && !isEdit) {
      waveInput.input.onChange("");
      routeInput.input.onChange("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schoolId]);

  useEffect(() => {
    const isBusSchedulePlanIdNotZero =
      Number(busSchedulePlanInput.input.value) !== 0;

    if (isEdit && isBusSchedulePlanIdNotZero) {
      provider
        .getOne("busSchedulePlans", {
          id: Number(busSchedulePlanInput.input.value),
        })
        .then(({ data }) => {
          waveInput.input.onChange(data.busScheduleId);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [busSchedulePlanInput.input.value]);

  return (
    <>
      {!isEdit ? (
        <ReferenceInput
          label="Select Wave"
          source="busScheduleId"
          reference="busSchedules"
          filter={{ SchoolId: schoolId, HasRoutePlan: true }}
          onChange={() => {
            routeInput.input.onChange("");
          }}
          disabled={isDisable}
          perPage={9999}
          validate={required()}
        >
          <SelectInput optionText="name" />
        </ReferenceInput>
      ) : (
        <ReferenceInput
          label="Select Wave"
          source="busScheduleId"
          reference="busSchedules"
          disabled={isDisable}
          perPage={9999}
          validate={required()}
        >
          <SelectInput optionText="name" />
        </ReferenceInput>
      )}
    </>
  );
};

export default WaveInput;
